import React, { useRef, useState } from 'react'
// import { useFilePicker } from 'use-file-picker';
import { Form, Button } from 'react-bootstrap'
import { Editor } from '@tinymce/tinymce-react';
import { useNavigate } from 'react-router-dom';
import { URL } from '../Services/Url';
import { useGlobalContext } from '../context/store'


export default function InputForm() {

  //Navigation
  const navigate = useNavigate();

  //Context/Props
  const { token, orgId } = useGlobalContext()


  // New Service Variables
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const serviceId = 0
  const [iconId, setIconId] = useState(0);
  // For TinyEditor
  const editorRef: any = useRef();

  const GetIconId = (newIconId: number) => {
    setIconId(newIconId)
  }

  //Fetch function
  const saveServiceByServiceId = async (title: string, description: string, iconId: number, orgId: number, serviceId: number) => {
    await fetch(
      `${URL}/Service/saveService`, {
      method: "Post",
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': "application/json",
      },
      body: JSON.stringify({
        "description": description,
        "iconId": iconId,
        "orgId": orgId,
        "serviceId": serviceId,
        "title": title,
      })
    }
    );
  };
  // Functions 
  const handleSubmit = () => {
    saveServiceByServiceId(title, description, iconId, orgId, serviceId);
    alert("New Service has been created");

    setTimeout(() => {
      navigate('/main')
    }, 2000);
  }


  const handleCancel = () => {
    navigate('/main')
  }
  return (
    <div>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Title</Form.Label>
          <Form.Control type="text" placeholder="Title" onChange={(e) => setTitle(e.target.value)} />

        </Form.Group>


        <Form.Group className="mb-3">
          <Form.Label>Description</Form.Label>
         
          <Editor
            tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
            onInit={(editor) => editorRef.current = editor}
            onEditorChange={(newText) => setDescription(newText)}
            init={{
              height: 500,
              menubar: false,
              plugins: [
                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                'insertdatetime', 'media', 'table', 'preview', 'help', 'wordcount'
              ],
              toolbar: 'undo redo | blocks | ' +
                'bold italic forecolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
              content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'

            }}
          />
        </Form.Group>
        <Form.Group className="pt-3">
     <select id='iconName' value={iconId} onChange={(e) => GetIconId(parseInt(e.target.value))}>
      <option value={1} >Service 1 icon</option>
      <option value={2} >Service 2 icon</option>
      <option value={3} >Service 3 icon</option>

     </select>
        </Form.Group>
      </Form>
      <div className="d-flex justify-content-end mb-5">

        <Button className="mx-3" onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleSubmit}>Submit</Button>
      </div>

      
    </div>
    
  )
}
